import { ICommand, IDefineCommand, IQuery, IQueryMediator } from 'core-ts-types';
import * as _4 from 'lodash4';
import { IStudygroupsPriorityFeedDatasource } from '../datasources/study_groups_priority_feed_datasource';

angular
  .module('capability-ng-priority-feed')
  .factory(
    'getStudyBuddyPriorityFeedCommand',
    (
      $q: ng.IQService,
      defineCommand: IDefineCommand,
      $http: ng.IHttpService,
      ngStudygroupsPriorityFeedDatasource: IStudygroupsPriorityFeedDatasource
    ): ICommand => {
      return defineCommand('getStudyBuddyPriorityFeedCommand', (deferred: ng.IDeferred<IQuery[]>): void => {
        $http
          .get('/study/priority_feed/')
          .then(({ data }: ng.IHttpPromiseCallbackArg<any>) => {
            ngStudygroupsPriorityFeedDatasource.clear();
            if (!_4.isEmpty(data)) {
              ngStudygroupsPriorityFeedDatasource.write([data]);
            }

            deferred.resolve();
          })
          .catch((response) => {
            return deferred.reject(response.data);
          });
      });
    }
  );



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-study-groups/src/commands/get_study_buddy_priority_feed_command.ts